import { AffiliationTabs } from "features/affiliation/common/types";
import { generatePath, useHistory } from "react-router-dom";
import { AFFILIATION_PATH } from "common/constants";
import useReferredUsers from "features/affiliation/common/hooks/useReferredUsers";
import useReferralLinks from "features/affiliation/common/hooks/useReferralLinks";
import usePayouts from "features/affiliation/common/hooks/usePayouts";
import {
  useEarnings,
  useEarningsBarChart,
} from "features/affiliation/common/hooks";

const useOverview = () => {
  const history = useHistory();
  const { referralLinksQuery } = useReferralLinks();
  const { referralHistoryQuery, referredChartQuery } = useReferredUsers(
    AffiliationTabs.REFERRED_USERS
  );
  const { commissionHistoryQuery } = useEarnings();
  const { earningsChartQuery } = useEarningsBarChart();
  const { payoutsHistoryQuery } = usePayouts();

  const isLoading =
    referralHistoryQuery.isLoading ||
    referralLinksQuery.isLoading ||
    commissionHistoryQuery.isLoading ||
    payoutsHistoryQuery.isLoading ||
    referredChartQuery.isLoading ||
    earningsChartQuery.isLoading;

  const onSeeAllClick = (tab: AffiliationTabs) => {
    history.push(
      generatePath(AFFILIATION_PATH, {
        tab: tab,
      })
    );
  };

  return {
    isLoading,
    onSeeAllClick,
  };
};

export default useOverview;
